import { logger } from '@/src/internal/logger';

/**
 * Logs an error indicating that the {@link FeatureFlagProvider} is being used in a test environment
 * context.
 */
export const logUsageContext = () => {
  logger.error(
    'The FeatureFlagProvider component should not be used in a test environment. Are you using ' +
      'the "MockApplicationConfig" component in your tests?',
    { env: process.env.NODE_ENV },
  );
};
